<template>
	<div class="card" :class="size">
	  <div class="card-header" v-if="header">
	  	<slot name="header"></slot>
	  </div>
	  <div class="card-body">
	    <slot name="content"></slot>
	  </div>
	  <div class="card-footer" v-if="hasFooterSlot">
	    <slot name="footer"></slot>
	  </div>
	</div>
</template>

<script>
	export default {
		name: 'layout.card',
		props: {
			header: {
				type: Boolean, 
				default: true
			},
			footer: {
				type: Boolean, 
			},
			size: {
				type: String,
				default: 'md'
			}
		},
		computed: {
			hasFooterSlot() {
			  return !!this.$slots.footer
			}
		}
	}
</script>